<mat-dialog-content>
  @if (form ) {
    <form [formGroup]="form">
      @if (userCanEditPage$|async) {
        <div class="w100 flex-center-center">
          <app-huna-button [loading]="savingUpdateSerial"
            color="primary"
            type="mat-flat-button"
            >
            <button mat-flat-button color="primary" style="padding: 5px"
              (click)="openSerialDialog(SERIALFORM)">
              {{ serialValue$|async }}
            </button>
          </app-huna-button>
        </div>
      }
      @if (visualizedInTabGroup) {
        <mat-tab-group>
          @for (tab of htmlData; track $index) {
            <mat-tab [label]="tab.tabGroupName|translate">
              @for (form of tab.forms; track $index) {
                <app-get-form-field-from-configuration-file
                  [type]="form.type"
                  [titleTraduction]="form.traduction"
                  [possibleValues]="form.possibleValues"
                  [min]="form.formOptions?.min"
                  [max]="form.formOptions?.max"
                  [formControlName]="form.formControlName"
                  >
                </app-get-form-field-from-configuration-file>
                @if (form.formGroupChild) {
                  <mat-card>
                    <ng-container [formGroupName]="form.formGroupChild.formGroupName">
                      @for (subForm of form.formGroupChild.fields; track $index) {
                        <app-get-form-field-from-configuration-file [type]="subForm.type"
                          [titleTraduction]="subForm.traduction"
                          [possibleValues]="subForm.possibleValues"
                          [formControlName]="subForm.formControlName">
                        </app-get-form-field-from-configuration-file>
                      }
                    </ng-container>
                  </mat-card>
                }
              }
            </mat-tab>
          }
          @if (visualize.iotConfiguration) {
            <app-huna-button [loading]="loading.iotConfiguration" color="primary" type="mat-flat-button"
              >
              <button mat-flat-button color="primary"
                [disabled]="form.disabled"
                (click)="openIotConfiguration()"
                >
                {{ 'IotDevices.configuration'|translate }}
              </button>
            </app-huna-button>
          }
        </mat-tab-group>
      } @else {
        @for (tab of htmlData; track $index) {
          @for (form of tab.forms; track $index) {
            <app-get-form-field-from-configuration-file
              [type]="form.type"
              [titleTraduction]="form.traduction"
              [possibleValues]="form.possibleValues"
              [min]="form.formOptions?.min"
              [max]="form.formOptions?.max"
              [formControlName]="form.formControlName"
              >
            </app-get-form-field-from-configuration-file>
            @if (form.formGroupChild) {
              <mat-card>
                <ng-container [formGroupName]="form.formGroupChild.formGroupName">
                  @for (subForm of form.formGroupChild.fields; track $index) {
                    <app-get-form-field-from-configuration-file [type]="subForm.type"
                      [titleTraduction]="subForm.traduction"
                      [possibleValues]="subForm.possibleValues"
                      [formControlName]="subForm.formControlName">
                    </app-get-form-field-from-configuration-file>
                  }
                </ng-container>
              </mat-card>
            }
          }
        }
      }
      <div class="w100 flex-between-center">
        @if (visualize.iotConfiguration) {
          <app-huna-button [loading]="loading.iotConfiguration" color="primary" type="mat-flat-button"
            >
            <button mat-flat-button color="primary" [disabled]="form.disabled"
              class="text-button"
              (click)="openIotConfiguration()">
              {{ 'IotDevices.configuration'|translate }}
            </button>
          </app-huna-button>
        }
        @if (visualize.iotPidConfigurations) {
          <app-huna-button [loading]="loading.iotPidConfigurations" color="primary" type="mat-flat-button"
            >
            <button mat-flat-button color="accent"
              class="text-button"
              [disabled]="form.disabled"
              (click)="openIotPidConfiguration()"
              >{{ 'IotDevices.pid_configurations'|translate }}
            </button>
          </app-huna-button>
        }
      </div>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button style="margin-right: 5px"
    color="accent"
    mat-flat-button
    mat-dialog-close>
    <mat-icon>clear</mat-icon>
  </button>
  @if (!form?.disabled) {
    <button color="primary" mat-flat-button
      [disabled]="this.form?.invalid||loading.iotConfiguration"
      (click)="clickSaveButton()">
      <mat-icon>save</mat-icon>
    </button>
  }
</mat-dialog-actions>


<ng-template #SERIALFORM>
  @if (formSerial) {
    <form [formGroup]="formSerial" class="w100"
      style="width:310px;margin: 10px ">
      <mat-form-field appearance="fill" class="w100">
        <mat-label>
          {{ 'IotDevices.seriale'|translate }}
        </mat-label>
        <input matInput formControlName="seriale">
      </mat-form-field>
      <div class="flex-evenly-center w100">
        <button mat-flat-button color="accent" (click)="closeSerial()">
          <mat-icon>clear</mat-icon>
        </button>
        <button mat-flat-button color="primary" (click)="saveSerial()">
          <mat-icon>save</mat-icon>
        </button>
      </div>
    </form>
  }
</ng-template>
